import { motion } from 'framer-motion'
import { features } from '../data.ts'
import React from 'react'

export default function Features() {
  return (
    <section className="relative py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-4 rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent p-6 sm:p-10 lg:grid-cols-4">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex flex-col items-start gap-3 lg:border-r lg:border-white/10 lg:last:border-r-0 lg:px-6 lg:first:pl-0"
            >
              <span className="grid h-10 w-10 place-items-center rounded-lg bg-brand-500/15 text-brand-300">
                <f.icon size={20} />
              </span>
              <h3 className="font-display text-base font-semibold text-white">{f.title}</h3>
              <p className="text-sm leading-relaxed text-slate-400">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
